import React, { useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import bannerBg from '../assets/img/page-banner.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import ServiceSidebar from '../components/ServiceSidebar';
import servicesOneData from '../components/Services4/servicesOneData';
import blogThreeData from '../components/services6/blogThreeData';
import productsData from '../components/data/products';
import BlogThreeItem from '../components/Blog3/BlogThreeItem';
import { AiOutlineRightCircle } from 'react-icons/ai';

function ServicesDetails() {
  const { slug } = useParams();
  const location = useLocation();

  useEffect(() => {
    // Scroll to the title if the hash matches or whenever slug changes
    const element = document.getElementById('service-title');
    if (element) {
      // Use setTimeout to ensure the DOM has updated before calculating position
      const scrollTimeout = setTimeout(() => {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
      return () => clearTimeout(scrollTimeout);
    }
  }, [slug, location.hash]);

  // Map service slug to product categories
  const mapServiceSlugToCategory = {
    'forging-cold-hot-warm': 'forged-components',
    'cnc-machining-cnc-vmc-hmc': 'machined-components',
    'grinding-cylindrical-surface': 'machined-components',
    'fasteners-manufacturing': 'fasteners',
    'sheet-metal-laser-cutting': 'sheet-metal-parts',
    'welding-fabrication': 'fabrication',
    'surface-treatment-plating': 'surface-treated',
    'aluminium-extrusion': 'aluminium-extrusion',
  };

  const service = servicesOneData.find(s => s.slug === slug) || blogThreeData.find(s => s.slug === slug);
  const mappedCategory = mapServiceSlugToCategory[slug];

  // Filter products based on mapped category
  const relatedProducts = mappedCategory
    ? productsData.filter(p => p.category.toLowerCase() === mappedCategory.toLowerCase())
    : [];

  if (!service) {
    return (
      <>
        <Header1 />
        <PageBanner bannerBg={bannerBg} currentPage="Service Not Found" heading="Error 404" />
        <section className="section-padding text-center">
          <h2>Service not found!</h2>
          <br />
          <Link to="/services" className="theme-btn">Back to Services</Link>
        </section>
        <Footer1 />
      </>
    );
  }

  return (
    <>
      <Header1 />
      {/* <PageBanner
                bannerBg={bannerBg}
                heading={service.heading || service.title}
                currentPage={service.heading || service.title}
            /> */}
      <section className="service-details-wrapper section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-4 mt-5 mb-5 mt-md-0 col-12 order-1 order-md-1">
              <ServiceSidebar activeService={slug} />
            </div>
            <div className="col-lg-9 col-md-8 col-12 order-2 order-md-2 mb-5">
              <div className="service-details-content-wrapper pl-0 pl-md-4">
                <div className="service-thumb mb-4">
                  <h1 id="service-title" style={{ scrollMarginTop: '120px' }}>{service.heading || service.title}</h1>
                  <img
                    src={service.bgImg || service.thumbnail}
                    alt={service.heading || service.title}
                    className="img-fluid w-100"
                    style={{
                      maxHeight: "400px",
                      objectFit: "cover",
                      borderRadius: "4px",
                    }}
                  />
                </div>
                <p className="mt-4 mb-5">
                  {service.description ||
                    `Welcome to our ${(
                      service.heading || service.title
                    ).toLowerCase()} service details page. Below you can discover all the capabilities and implementations we offer corresponding to this service.`}
                </p>

                <h3>Capabilities & Offerings</h3>
                <ul style={{ listStyleType: "disc" }}>
                  {service.subServices && service.subServices.length > 0 ? (
                    service.subServices.map((sub, idx) => (
                      <li key={idx}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#5A9980"
                            d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8z"
                          />
                        </svg>
                        {sub}
                      </li>
                    ))
                  ) : (
                    <li>No sub-services available</li>
                  )}
                </ul>
                {/* <div className="row mt-4">
                                    {service.subServices && service.subServices.length > 0 ? (
                                        service.subServices.map((sub, idx) => (
                                            <div className="col-xl-4 col-md-6 col-12 mb-4" key={idx}>
                                                <div className="single-news-card" style={{ height: '100%' }}>
                                                    <div className="post-content" style={{ padding: '30px', marginTop: 0 }}>
                                                        <h3 style={{ textTransform: 'capitalize', fontSize: '20px', lineHeight: '1.4' }}>
                                                            {sub}
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : relatedProducts.length > 0 ? (
                                        relatedProducts.map((data) => (
                                            <BlogThreeItem
                                                key={data.id}
                                                thumb={data.thumbnail}
                                                title={data.title}
                                                author={data.author || 'Vedant Tech'}
                                                meta={data.meta || 'Product'}
                                                category={data.category}
                                                slug={data.slug}
                                            />
                                        ))
                                    ) : (
                                        <div className="col-12">
                                            <p style={{ paddingTop: '15px' }} >Currently, no specific sub-services are registered for this capability. Please contact us for further specific catalogs.</p>
                                        </div>
                                    )}
                                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer1 />
    </>
  );
}

export default ServicesDetails;
